ux-iws-search-tag-filter {
    display: block;
}

.ux-iws-search-tag-filter {
    &__slot {
        display: none;
    }

    &__container {
        display: block;
    }
}

// TODO: styles copied from ux-filter css
.ux-iws-search-tag-filter__reset {
    appearance: none;
    border: 0 none;
    font-weight: bold;
    align-items: center;
    background-color: transparent;
    color: $color-black;
    cursor: pointer;
    display: inline-flex;
    flex-flow: row nowrap;
    font-size: $size-text-smaller;
    justify-content: center;
    line-height: 1;
    margin-bottom: $dim-10;
    min-height: $dim-30;
    padding: 5px 0;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;

    ux-icon[name="close"] {
        font-size: 10px;
        margin-left: 10px;
    }

    &::after {
        background-color: $color-black;
        bottom: 0;
        content: "";
        display: block;
        height: 1px;
        left: 0;
        position: absolute;
        transform: scaleX(0);
        transform-origin: 0 0;
        transition: transform $animationSpeed-fast ease-out;
        width: 100%;
    }

    &:hover::after {
        transform: none;
    }
}
